import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setView } from 'actions/lists';
import { getView } from 'selectors/lists';
import { views } from '../constants';
import { RadioGroupStyle, Separator } from 'components/Search/Results/Title';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    margin-bottom: 10px;
  }
`;

const Title = ({ hasOrgLicense, loading }) => {
  const dispatch = useDispatch();
  const view = useSelector(getView);
  const handleChangeView = view => {
    dispatch(setView(view.target.value));
  };

  const viewOptions = useMemo(() => {
    const options = [{ label: 'Contacts', value: views.researchers }];

    if (hasOrgLicense) {
      options.push({ label: 'Organisations', value: views.organisations });
    }

    return options;
  }, [hasOrgLicense]);

  return (
    <Container>
      <div className='title'>Lists</div>
      <RadioGroupStyle
        disabled={loading}
        buttonStyle='solid'
        value={view}
        optionType='button'
        onChange={handleChangeView}
        style={{
          display: viewOptions.length > 1 ? 'inline-block' : 'none',
          marginRight: '10px',
        }}
        size='middle'
        defaultOpen={views.researchers}
        data-testid='radio-view-options'
      >
        <Separator options={viewOptions} />
      </RadioGroupStyle>
    </Container>
  );
};

export default Title;
